<!-- 拣货单打印组件（成品订单status=350） -->
<template>
  <el-dialog
    title="拣货单打印"
    :visible.sync="dialogVisible"
    center
    :close-on-click-modal="false"
    :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="pickupPrintContent" style="width:100%;margin:0 auto;padding:10px 0;">
      <!-- 标题 -->
      <!--<p style="text-align:center;font-size:18px;line-height:40px;font-weight:bold;margin:5px 0;">拣货单</p>-->

      <!-- 1. 顶部备注区域 -->
      <div v-if="remarkDisplay"  style="border:1px solid #333;padding:14px;margin-bottom:12px;min-height:32px;line-height:2.0;font-size:12pt;">
        <span v-html="remarkDisplay"></span>
      </div>

      <!-- 2. 订单信息（每项单独一行） -->
      <table style="width:100%;border-collapse:collapse;font-size:12pt;">
        <tr>
          <td style="width:75px;padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>订单日期：</b></td>
          <td style="padding:5px 8px;font-size:12pt;">{{orderDate}}</td>
        </tr>
        <tr>
          <td style="padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>打印日期：</b></td>
          <td style="padding:5px 8px;font-size:12pt;">{{printDate}}</td>
        </tr>
        <tr>
          <td style="padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>订单号：</b></td>
          <td style="padding:5px 8px;font-size:10pt;">
            {{erpserial}}<br>
            <svg ref="barcodeSvg" style="height:32px;display:block;margin-top:4px;"></svg>
          </td>
        </tr>
        <tr>
          <td style="padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>客户名称：</b></td>
          <td style="padding:5px 8px;font-weight:bold;font-size:12pt;">{{customername}}</td>
        </tr>
      </table>

      <!-- 3. 镜片商品区域（按产品名称分组，每组独立显示） -->
      <div v-if="lensGroups.length > 0" style="margin-top:15px;">
        <div v-for="(group, gIdx) in lensGroups" :key="'lg' + gIdx" style="margin-bottom:12px;">
          <div style="font-weight:bold;font-size:12pt;margin-bottom:6px;">{{group.name}}</div>
          <table style="width:100%;border-collapse:collapse;font-size:12pt;" class="query-table">
            <tr>
              <td style="text-align:center;border:1px solid #000;font-size:10pt;width:65px;">球镜</td>
              <td style="text-align:center;border:1px solid #000;font-size:10pt;width:65px;">柱镜</td>
              <td style="text-align:center;border:1px solid #000;font-size:10pt;width:65px;">ADD</td>
              <td style="text-align:center;border:1px solid #000;font-size:10pt;width:55px;">数量</td>
            </tr>
            <tr v-for="(item, iIdx) in group.items" :key="'l' + gIdx + '-' + iIdx">
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['球镜'] !== undefined ? item['球镜'] : ''}}</td>
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['柱镜'] !== undefined ? item['柱镜'] : ''}}</td>
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['ADD'] !== undefined ? item['ADD'] : ''}}</td>
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['数量'] !== undefined ? item['数量'] : 0}}</td>
            </tr>
            <tr :key="'ls' + gIdx">
              <td colspan="3" style="text-align:right;padding:6px 12px;border:1px solid #000;font-size:10pt;">小计：</td>
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:12pt;">{{formatInt(group.subtotal)}}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 3. 镜架商品区域（按品牌分组，每组独立显示） -->
      <div v-if="frameGroups.length > 0" style="margin-top:15px;">
        <div v-for="(group, gIdx) in frameGroups" :key="'fg' + gIdx" style="margin-bottom:12px;">
          <div style="font-weight:bold;font-size:12pt;margin-bottom:6px;">{{group.name}}</div>
          <table style="width:100%;border-collapse:collapse;font-size:12pt;" class="query-table">
            <tr>
              <td style="text-align:center;border:1px solid #000;font-size:10pt;">型号</td>
              <td style="text-align:center;border:1px solid #000;font-size:10pt;">色号</td>
              <td style="text-align:center;border:1px solid #000;font-size:10pt;width:55px;">数量</td>
            </tr>
            <tr v-for="(item, iIdx) in group.items" :key="'f' + gIdx + '-' + iIdx">
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['型号'] || ''}}</td>
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['色号'] || ''}}</td>
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['数量'] || 0}}</td>
            </tr>
            <tr :key="'fs' + gIdx">
              <td colspan="2" style="text-align:right;padding:6px 12px;border:1px solid #000;font-size:10pt;">小计：</td>
              <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:12pt;">{{formatInt(group.subtotal)}}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 4. 底部总数与打单人 -->
      <div style="margin-top:15px;font-size:12pt;line-height:2.2;">
        <span style="font-weight:bold;font-size:12pt;">总数：{{formatInt(totalQuantity)}}</span>
        <span style="float:right;">打单人：{{printerName}}</span>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import JsBarcode from 'jsbarcode'
import { getRemark } from '@/plugin/ordercommon'

export default {
  name: 'PickupPrint',
  data() {
    return {
      dialogVisible: false,
      controlData: null,
      goodsDetail: [],
      userInfoModel: null
    }
  },
  computed: {
    // 镜片商品（包含球镜字段）
    lensItems() {
      return this.goodsDetail.filter(item => item['球镜'] !== undefined)
    },
    // 镜架商品（不包含球镜字段）
    frameItems() {
      return this.goodsDetail.filter(item => item['球镜'] === undefined)
    },
    // 镜片按产品名称分组
    lensGroups() {
      const groups = {}
      for (const item of this.lensItems) {
        const name = item['产品名称'] || '未知'
        if (!groups[name]) {
          groups[name] = { name, items: [], subtotal: 0 }
        }
        groups[name].items.push(item)
        groups[name].subtotal += (parseFloat(item['数量']) || 0)
      }
      return Object.values(groups)
    },
    // 镜架按品牌分组（品牌从产品名称中提取，依次替换掉型号、色号的值）
    frameGroups() {
      const groups = {}
      for (const item of this.frameItems) {
        const productName = item['产品名称'] || '未知'
        let brand = productName
        // 从商品名称中替换掉型号和色号的值来提取品牌
        if (item['型号']) {
          brand = brand.replace(item['型号'], '').trim()
        }
        if (item['色号']) {
          brand = brand.replace(item['色号'], '').trim()
        }
        // 清理分隔符
        brand = brand.replace(/[-–—/\\]/g, '').trim()
        if (!brand) brand = productName

        if (!groups[brand]) {
          groups[brand] = { name: brand, items: [], subtotal: 0 }
        }
        groups[brand].items.push(item)
        groups[brand].subtotal += (parseFloat(item['数量']) || 0)
      }
      return Object.values(groups)
    },
    totalQuantity() {
      return this.goodsDetail.reduce((sum, item) => sum + (parseFloat(item['数量']) || 0), 0)
    },
    erpserial() {
      return this.controlData ? (this.controlData.erpserial || '') : ''
    },
    customername() {
      return this.controlData ? (this.controlData.customername || '') : ''
    },
    orderDate() {
      return this.controlData ? (this.controlData.htqd || this.controlData.adddate || '') : ''
    },
    printDate() {
      const now = new Date()
      const pad = n => String(n).padStart(2, '0')
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
    },
    printerName() {
      return this.userInfoModel ? (this.userInfoModel.uname || '') : ''
    },
    // 解析备注（过滤掉人员和日期信息）
    remarkDisplay() {
      if (!this.controlData || !this.controlData.remark) return ''
      var html = getRemark(this.controlData.remark)
      // 去掉中文括号包裹的内容（人员和日期）
      return html.replace(/（[^）]*?）/g, '')
    }
  },
  methods: {
    show(controlData, goodsDetail, userInfoModel) {
      this.controlData = controlData
      this.goodsDetail = goodsDetail || []
      this.userInfoModel = userInfoModel
      this.dialogVisible = true
      this.$nextTick(() => {
        this.renderBarcode()
        this.$nextTick(() => {
          this.$print(this.$refs.pickupPrintContent)
          this.dialogVisible = false
        })
      })
    },
    renderBarcode() {
      if (this.$refs.barcodeSvg && this.erpserial) {
        try {
          JsBarcode(this.$refs.barcodeSvg, this.erpserial, {
            format: 'CODE128',
            width: 2,
            height: 32,
            displayValue: false,
            margin: 5,
            background: '#ffffff'
          })
        } catch (e) {
          console.error('Barcode render error:', e)
        }
      }
    },
    formatInt(val) {
      const num = parseInt(val)
      return isNaN(num) ? '0' : String(num)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/PickupPrint.vue